import {defineMessages} from 'react-intl';

export const feedbackMessages = defineMessages({
  buttonLabel: { id: 'feedback.button_label' },
  title: { id: 'feedback.title' },
  messageLabel: { id: 'feedback.message_label' },
  messagePlaceholder: {
    id: 'feedback.message_placeholder',
  },
  attachmentsLabel: { id: 'feedback.attachments_label' },
  attachmentsInfo: {
    id: 'feedback.attachments_info',
  },
  attachmentsButton: {
    id: 'feedback.attachments_button',
  },
  contactLabel: {
    id: 'feedback.contact_label',
  },
  contactInfo: {
    id: 'feedback.contact_info',
  },
  contactPlaceholder: {
    id: 'feedback.contact_placeholder',
  },
  slideSpecific: {
    id: 'feedback.slide_specific',
  },
  maximumNumberOfFiles: {
    id: 'feedback.max_files_number',
  },
  maximumFileSize: {
    id: 'feedback.maximum_file_size',
  },
  thankYou: {
    id: 'feedback.thank_you',
  },
  clientConfirmHeader: {
    id: 'feedback.try_with_email_app',
  },
  clientConfirmMessage: {
    id: 'feedback.email_confirm_text',
  },
  maxBodyLength: {
    id: 'feedback.max_body_length',
  },
  invalidFileFormat: {
    id: 'feedback.invalid_file_format',
  },
});
